



























import modal from '@/components/includes/Modal.vue';
import ENV from '@/environment';

const COOKIE_CONSENT_KEY = 'byCookieConsent';

export default {
  name: 'CookieModal',
  components: {
    modal,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    this.isVisible =
      ENV.REGION === 'by' && !localStorage.getItem(COOKIE_CONSENT_KEY);
  },
  methods: {
    agree() {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'agreed');
      this.isVisible = false;
    },
    disagree() {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
      this.isVisible = false;
    },
  },
};
